import eventDateListTemplate from './event_date_list.template.html';

angular.module('bl.eventDateList').component('blEventDateList', {
    templateUrl: eventDateListTemplate.id,
    controller: ['$scope', '$rootScope', 'halClient', 'BBModel', blEventDateListController],
    controllerAs: "$eventDateListCtrl",
    bindings: {
        event: '<'
    }
});

function blEventDateListController($scope, $rootScope, halClient, BBModel) {
    this.isMultiDay = false;
    this.datePicked = false;
    this.tempAllEvents = [];
    this.selectedEvent = this.event.id;

    let newDate = new Date();
    let thisYear = newDate.getFullYear();
    let nextYear = newDate.getFullYear() + 1;

    // get start date and end date of this year
    let start_date = new Date(thisYear, 0, 1).toISOString().split('T')[0];
    let end_date = new Date(thisYear, 11, 31).toISOString().split('T')[0];

    // get start date and end date of next year
    let next_start_date = new Date(nextYear, 0, 1).toISOString().split('T')[0];
    let next_end_date = new Date(nextYear, 11, 31).toISOString().split('T')[0];

    this.params = {
        start_date,
        end_date,
        per_page: 99999 // dont look at this
    }

    this.nextYearParams = {
        start_date: next_start_date,
        end_date: next_end_date,
        per_page: 99999 // dont look at this
    }


    if (this.event.multiDay || $scope.$parent.event.multiDay) {
        this.isMultiDay = true;
    } else {
        $scope.$parent.bookableEvent = true;
    }

    const self = this;
    this.event.$getEventChain(this.params).then(res => {
        res.$getEvents(this.params).then(resThisYear => {
            this.event.$getEventChain(this.nextYearParams).then(res => {
                res.$getEvents(this.nextYearParams).then(resNextYear => {
                    console.log(resThisYear);
                    console.log(resNextYear);
                    self.tempAllEvents = [...resThisYear, ...resNextYear];
                });
            });
        });
    });



    this.update = async function () {
        const self = this;

        // find the event the user selected
        this.foundEvent = this.tempAllEvents.find(function (event) {
            return event.id == Number(self.selectedEvent);
        });

        // Put the multiday event variable back on the event
        this.foundEvent.multiDay = true;

        this.foundEvent.price_range = this.event.price_range;
        this.foundEvent.ticket_prices = this.event.ticket_prices;
        this.foundEvent.tickets = this.event.tickets;
        this.foundEvent.chain = this.event.chain;

        // set the event on parent
        $scope.$parent.event = this.foundEvent;

        // show button to let the user continue
        $scope.$parent.bookableEvent = true;
    }

    $scope.$parent.bookButton = function () {
        $scope.$parent.selectItem($scope.$parent.event);
        $scope.$parent.$parent.showPage('templates/public-booking/steps/login');
    }
}


// WEBPACK FOOTER //
// src/public/javascripts/event-date-picker/event_date_list.component.js